import { render, staticRenderFns } from "./Chapter5_2.vue?vue&type=template&id=a53c375c&scoped=true&"
import script from "./Chapter5_2.vue?vue&type=script&lang=js&"
export * from "./Chapter5_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53c375c",
  null
  
)

export default component.exports